/**
 * @fileoverview gRPC-Web generated client stub for order_reported_problem_type
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.21.12
// source: protobuf/order_reported_problem_type/type.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as protobuf_model_merged_pb from '../../protobuf/model/merged_pb';
import * as protobuf_order_reported_problem_type_type_pb from '../../protobuf/order_reported_problem_type/type_pb';


export class OrderReportedProblemTypeServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorCreate = new grpcWeb.MethodDescriptor(
    '/order_reported_problem_type.OrderReportedProblemTypeService/Create',
    grpcWeb.MethodType.UNARY,
    protobuf_order_reported_problem_type_type_pb.CreateOrderReportedProblemTypeRequest,
    protobuf_model_merged_pb.OrderReportedProblemTypeResponse,
    (request: protobuf_order_reported_problem_type_type_pb.CreateOrderReportedProblemTypeRequest) => {
      return request.serializeBinary();
    },
    protobuf_model_merged_pb.OrderReportedProblemTypeResponse.deserializeBinary
  );

  create(
    request: protobuf_order_reported_problem_type_type_pb.CreateOrderReportedProblemTypeRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_model_merged_pb.OrderReportedProblemTypeResponse>;

  create(
    request: protobuf_order_reported_problem_type_type_pb.CreateOrderReportedProblemTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.OrderReportedProblemTypeResponse) => void): grpcWeb.ClientReadableStream<protobuf_model_merged_pb.OrderReportedProblemTypeResponse>;

  create(
    request: protobuf_order_reported_problem_type_type_pb.CreateOrderReportedProblemTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.OrderReportedProblemTypeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_reported_problem_type.OrderReportedProblemTypeService/Create',
        request,
        metadata || {},
        this.methodDescriptorCreate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_reported_problem_type.OrderReportedProblemTypeService/Create',
    request,
    metadata || {},
    this.methodDescriptorCreate);
  }

  methodDescriptorUpdate = new grpcWeb.MethodDescriptor(
    '/order_reported_problem_type.OrderReportedProblemTypeService/Update',
    grpcWeb.MethodType.UNARY,
    protobuf_order_reported_problem_type_type_pb.UpdateOrderReportedProblemTypeRequest,
    protobuf_model_merged_pb.OrderReportedProblemTypeResponse,
    (request: protobuf_order_reported_problem_type_type_pb.UpdateOrderReportedProblemTypeRequest) => {
      return request.serializeBinary();
    },
    protobuf_model_merged_pb.OrderReportedProblemTypeResponse.deserializeBinary
  );

  update(
    request: protobuf_order_reported_problem_type_type_pb.UpdateOrderReportedProblemTypeRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_model_merged_pb.OrderReportedProblemTypeResponse>;

  update(
    request: protobuf_order_reported_problem_type_type_pb.UpdateOrderReportedProblemTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.OrderReportedProblemTypeResponse) => void): grpcWeb.ClientReadableStream<protobuf_model_merged_pb.OrderReportedProblemTypeResponse>;

  update(
    request: protobuf_order_reported_problem_type_type_pb.UpdateOrderReportedProblemTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.OrderReportedProblemTypeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_reported_problem_type.OrderReportedProblemTypeService/Update',
        request,
        metadata || {},
        this.methodDescriptorUpdate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_reported_problem_type.OrderReportedProblemTypeService/Update',
    request,
    metadata || {},
    this.methodDescriptorUpdate);
  }

  methodDescriptorGet = new grpcWeb.MethodDescriptor(
    '/order_reported_problem_type.OrderReportedProblemTypeService/Get',
    grpcWeb.MethodType.UNARY,
    protobuf_order_reported_problem_type_type_pb.GetOrderReportedProblemTypesRequest,
    protobuf_order_reported_problem_type_type_pb.GetOrderReportedProblemTypesResponse,
    (request: protobuf_order_reported_problem_type_type_pb.GetOrderReportedProblemTypesRequest) => {
      return request.serializeBinary();
    },
    protobuf_order_reported_problem_type_type_pb.GetOrderReportedProblemTypesResponse.deserializeBinary
  );

  get(
    request: protobuf_order_reported_problem_type_type_pb.GetOrderReportedProblemTypesRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_order_reported_problem_type_type_pb.GetOrderReportedProblemTypesResponse>;

  get(
    request: protobuf_order_reported_problem_type_type_pb.GetOrderReportedProblemTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_order_reported_problem_type_type_pb.GetOrderReportedProblemTypesResponse) => void): grpcWeb.ClientReadableStream<protobuf_order_reported_problem_type_type_pb.GetOrderReportedProblemTypesResponse>;

  get(
    request: protobuf_order_reported_problem_type_type_pb.GetOrderReportedProblemTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_order_reported_problem_type_type_pb.GetOrderReportedProblemTypesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_reported_problem_type.OrderReportedProblemTypeService/Get',
        request,
        metadata || {},
        this.methodDescriptorGet,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_reported_problem_type.OrderReportedProblemTypeService/Get',
    request,
    metadata || {},
    this.methodDescriptorGet);
  }

  methodDescriptorDelete = new grpcWeb.MethodDescriptor(
    '/order_reported_problem_type.OrderReportedProblemTypeService/Delete',
    grpcWeb.MethodType.UNARY,
    protobuf_order_reported_problem_type_type_pb.DeleteOrderReportedProblemTypesRequest,
    protobuf_order_reported_problem_type_type_pb.DeleteOrderReportedProblemTypesResponse,
    (request: protobuf_order_reported_problem_type_type_pb.DeleteOrderReportedProblemTypesRequest) => {
      return request.serializeBinary();
    },
    protobuf_order_reported_problem_type_type_pb.DeleteOrderReportedProblemTypesResponse.deserializeBinary
  );

  delete(
    request: protobuf_order_reported_problem_type_type_pb.DeleteOrderReportedProblemTypesRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_order_reported_problem_type_type_pb.DeleteOrderReportedProblemTypesResponse>;

  delete(
    request: protobuf_order_reported_problem_type_type_pb.DeleteOrderReportedProblemTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_order_reported_problem_type_type_pb.DeleteOrderReportedProblemTypesResponse) => void): grpcWeb.ClientReadableStream<protobuf_order_reported_problem_type_type_pb.DeleteOrderReportedProblemTypesResponse>;

  delete(
    request: protobuf_order_reported_problem_type_type_pb.DeleteOrderReportedProblemTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_order_reported_problem_type_type_pb.DeleteOrderReportedProblemTypesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_reported_problem_type.OrderReportedProblemTypeService/Delete',
        request,
        metadata || {},
        this.methodDescriptorDelete,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_reported_problem_type.OrderReportedProblemTypeService/Delete',
    request,
    metadata || {},
    this.methodDescriptorDelete);
  }

  methodDescriptorList = new grpcWeb.MethodDescriptor(
    '/order_reported_problem_type.OrderReportedProblemTypeService/List',
    grpcWeb.MethodType.UNARY,
    protobuf_order_reported_problem_type_type_pb.ListOrderReportedProblemTypesRequest,
    protobuf_order_reported_problem_type_type_pb.ListOrderReportedProblemTypesResponse,
    (request: protobuf_order_reported_problem_type_type_pb.ListOrderReportedProblemTypesRequest) => {
      return request.serializeBinary();
    },
    protobuf_order_reported_problem_type_type_pb.ListOrderReportedProblemTypesResponse.deserializeBinary
  );

  list(
    request: protobuf_order_reported_problem_type_type_pb.ListOrderReportedProblemTypesRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_order_reported_problem_type_type_pb.ListOrderReportedProblemTypesResponse>;

  list(
    request: protobuf_order_reported_problem_type_type_pb.ListOrderReportedProblemTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_order_reported_problem_type_type_pb.ListOrderReportedProblemTypesResponse) => void): grpcWeb.ClientReadableStream<protobuf_order_reported_problem_type_type_pb.ListOrderReportedProblemTypesResponse>;

  list(
    request: protobuf_order_reported_problem_type_type_pb.ListOrderReportedProblemTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_order_reported_problem_type_type_pb.ListOrderReportedProblemTypesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_reported_problem_type.OrderReportedProblemTypeService/List',
        request,
        metadata || {},
        this.methodDescriptorList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_reported_problem_type.OrderReportedProblemTypeService/List',
    request,
    metadata || {},
    this.methodDescriptorList);
  }

  methodDescriptorExport = new grpcWeb.MethodDescriptor(
    '/order_reported_problem_type.OrderReportedProblemTypeService/Export',
    grpcWeb.MethodType.UNARY,
    protobuf_order_reported_problem_type_type_pb.ExportOrderReportedProblemTypesRequest,
    protobuf_order_reported_problem_type_type_pb.ExportOrderReportedProblemTypesResponse,
    (request: protobuf_order_reported_problem_type_type_pb.ExportOrderReportedProblemTypesRequest) => {
      return request.serializeBinary();
    },
    protobuf_order_reported_problem_type_type_pb.ExportOrderReportedProblemTypesResponse.deserializeBinary
  );

  export(
    request: protobuf_order_reported_problem_type_type_pb.ExportOrderReportedProblemTypesRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_order_reported_problem_type_type_pb.ExportOrderReportedProblemTypesResponse>;

  export(
    request: protobuf_order_reported_problem_type_type_pb.ExportOrderReportedProblemTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_order_reported_problem_type_type_pb.ExportOrderReportedProblemTypesResponse) => void): grpcWeb.ClientReadableStream<protobuf_order_reported_problem_type_type_pb.ExportOrderReportedProblemTypesResponse>;

  export(
    request: protobuf_order_reported_problem_type_type_pb.ExportOrderReportedProblemTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_order_reported_problem_type_type_pb.ExportOrderReportedProblemTypesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/order_reported_problem_type.OrderReportedProblemTypeService/Export',
        request,
        metadata || {},
        this.methodDescriptorExport,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/order_reported_problem_type.OrderReportedProblemTypeService/Export',
    request,
    metadata || {},
    this.methodDescriptorExport);
  }

}

